import { EnvSchema } from '../entities/envSchema';

const anhui: EnvSchema = {
  env: 'anhui',
  envName: '安徽数智财务',
};

export default anhui;
